/* eslint-disable no-underscore-dangle */
import BaseService from '@/services/BaseService';

class TimesheetService extends BaseService {
  /**
   * Get timesheet data for user
   *
   * @param {number} id user id
   */
  getUserTimesheet(id) {
    this._refreshInstance();
    return this.axios.get(`/user/${id}/timesheet`)
      .then(this.helpers._dataOnly)
      .catch(this.helpers._catch(null, true));
  }

  /**
   * Submit user timesheet for approval
   *
   * @param {number} id user id
   */
  submitForApproval(id, cutoff, month, year) {
    this._refreshInstance();
    return this.axios.post('/timesheet/submit', {
      id,
      cutoff,
      month,
      year,
    })
      .then(this.helpers._dataOnly)
      .catch(this.helpers._catch(null, true));
  }

  /**
   * Check if user is the approver
   *
   * @param {number} id
   * @param {string} key
   */
  checkIfApprover(id, key) {
    this._refreshInstance();
    const params = { id, key };
    return this.axios.get('/timesheet/check-approver/', { params })
      .then(this.helpers._dataOnly)
      .catch(this.helpers._catch(null, true));
  }

  /**
   * Get timesheet data using approval key
   *
   * @param {string} key approval key
   */
  async getTimesheetByKey(key) {
    this._refreshInstance();
    return this.axios.get(`/timesheet/key/${key}`)
      .then(this.helpers._dataOnly)
      .catch(this.helpers._catch(null, true));
  }

  /**
   * Get timesheet data using id
   *
   * @param {string} id timesheet id
   */
  async getTimesheetById(id, withCSV = false) {
    this._refreshInstance();
    const csvQ = withCSV ? '?withCSV=true' : '';
    return this.axios.get(`/timesheet/${id}${csvQ}`)
      .then(this.helpers._dataOnly)
      .catch(this.helpers._catch(null, true));
  }

  /**
   * Approve or reject timesheet (and other actions referring to status)
   * @param {string} action
   * @param {string} key
   * @param {number} approverId
   * @param {string} comments
   */
  async updateApprovalStatus(action, key, approverId, comments) {
    return this.post(`/timesheet/${action}`, { key, id: approverId, comments });
  }
}

export default TimesheetService;
